import { Controller } from "stimulus";
import { debounce, getCSRFToken } from "../util";
import { EventPriceLoaded } from "../events";
import Cookies from "js-cookie";

export default class extends Controller {
  static targets = ["coinResultsList", "coinSearchInput", "portfolioCoin", "emptyNotice"];

  connect() {
    this.debouncedSearchCoin = debounce(this.searchCoin.bind(this), 300);

    if (this.hasPortfolioCoinTarget) {
      $(this.portfolioCoinTarget).sortable({
        handle: ".handle",
        nested: false,
        vertical: false,
        placeholder:
          "portfolio_coin col-12 col-sm-6 col-lg-4 col-xl-3 col-xxl-5-cols dashboard-favourite ui-sortable-placeholder portfolio-placeholder portfolio_coin",
        items: ".portfolio_coin:not(.locked)",
        start() {
          $(".price-highlight-placeholder").css("z-index", 9999);

          // Inspired from http://stackoverflow.com/questions/4299241/jquery-sortable-lists-and-fixed-locked-items
          return $(".locked", this).each(function() {
            const $this = $(this);
            return $this.data("pos", $this.index() - 2);
          });
        },

        //# Hack minus 2 to make it work here for some unknown reason :(
        change() {
          const $sortable = $(this);
          const $statics = $(".locked", this).detach();
          const $helper = $(
            '<div class="col-md-4" style="border: 1px solid rgb(239, 239, 239); height: 512px; "></div>'
          ).prependTo(this);
          $statics.each(function() {
            const $this = $(this);
            const target = $this.data("pos");
            return $this.insertAfter($(".portfolio_coin", $sortable).eq(target));
          });
          return $helper.remove();
        },

        stop() {
          return $(".price-highlight-placeholder").css("z-index", -9999);
        },

        update() {
          return fetch($(this).data("update-url"), {
            headers: {
              "Content-Type": "application/json",
              "X-CSRF-Token": getCSRFToken()
            },
            method: "POST",
            credentials: "same-origin",
            body: JSON.stringify({
              metric_current: $(this)
                .sortable("toArray")
                .map(id => {
                  const splitArray = id.split("_");
                  return +splitArray[splitArray.length - 1];
                })
            })
          });
        }
      });
    }

    $("#addCoinModal").on("hidden.bs.modal", e => {
      this.coinSearchInputTarget.value = "";
      this.coinSearchInputTarget.classList.remove("loading");
      this.coinResultsListTarget.innerHTML = "";
    });

    $("#addCoinModal").on("shown.bs.modal", e => {
      this.coinSearchInputTarget.focus();
    });
  }

  searchCoin() {
    this.coinSearchInputTarget.classList.add("loading");
    let coinSearchInput = this.coinSearchInputTarget.value.trim();

    // Keep track of latest search query
    this._searchCount = this._searchCount || 0;
    this._searchCount += 1;
    const searchCount = this._searchCount;

    fetch(`portfolios/search?query=${coinSearchInput}`, {
      credentials: "same-origin"
    })
      .then(response => response.text())
      .then(res => {
        if (searchCount != this._searchCount) {
          // Old search result coming in late. Ignore.
          return;
        }

        if (res) {
          this.coinSearchInputTarget.classList.remove("loading");
          this.coinResultsListTarget.innerHTML = res;
        }
      });
  }

  // Used in dashboard and coin list (star)
  addCoin(e) {
    let coinId = e.currentTarget.getAttribute("data-coin-id");
    let source = e.currentTarget.getAttribute("data-source");

    fetch(`/portfolio/coins/${coinId}`, {
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "X-CSRF-Token": getCSRFToken()
      },
      method: "POST",
      credentials: "same-origin",
      body: JSON.stringify({ source: source })
    })
      .then(response => {
        if (response.redirected) {
          Cookies.set('from', 'index');
          window.location = response.url;
          return;
        }

        return response.text();
      })
      .then(res => {
        if (res) {
          if (this.hasEmptyNoticeTarget) {
            this.emptyNoticeTarget.style.display = "none";
          }

          if (this.hasPortfolioCoinTarget) {
            this.portfolioCoinTarget.insertAdjacentHTML("beforeend", res);

            // Force formatter to kick in!
            this.element.dispatchEvent(new CustomEvent(EventPriceLoaded, { bubbles: true }));
          }
        }
      });

    e.preventDefault();
  }

  // Used in dashboard and coin list (star)
  deleteCoin(e) {
    let coinId = e.currentTarget.getAttribute("data-coin-id");
    let coinName = e.currentTarget.getAttribute("data-coin-name");
    let currentCardElement = document.getElementById(e.currentTarget.getAttribute("data-dom-id"));
    let source = e.currentTarget.getAttribute("data-source");

    // If coin name present, ask for confirmation
    if (coinName && !confirm(`Are you sure you want to delete ${coinName}?`)) {
      return;
    }

    fetch(`/portfolio/coins/${coinId}`, {
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "X-CSRF-Token": getCSRFToken()
      },
      method: "DELETE",
      credentials: "same-origin",
      body: JSON.stringify({ source: source })
    })
      .then(response => response.text())
      .then(res => {
        if (currentCardElement) {
          currentCardElement.parentElement.removeChild(currentCardElement);
        }

        if (document.querySelectorAll(".dashboard-favourite-coin").length === 0) {
          if (this.hasEmptyNoticeTarget) {
            this.emptyNoticeTarget.style.display = "";
          }
        }
      });

    e.preventDefault();
  }
}
